import { render, staticRenderFns } from "./Pairing.vue?vue&type=template&id=137fd6c1&scoped=true&"
import script from "./Pairing.vue?vue&type=script&lang=js&"
export * from "./Pairing.vue?vue&type=script&lang=js&"
import style0 from "./Pairing.vue?vue&type=style&index=0&id=137fd6c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137fd6c1",
  null
  
)

export default component.exports